import { render, staticRenderFns } from "./GymSmallCard.vue?vue&type=template&id=332604e5"
import script from "./GymSmallCard.vue?vue&type=script&lang=js"
export * from "./GymSmallCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports